<template>
  <confirm-dialog
    ref="confirmModal"
    :title="deleteConfirmationTitle"
    @ok="deleteCustomField"
    ok-title="Yes, I understand, delete."
    ok-variant="danger"
    cancel-title="No, I changed my mind"
  >
    <p v-if="isOrgLevelCF">
      <b>Important:</b> This custom field is currently available to your entire organization and all
      it’s goals. It may be used by other people in your organization.
    </p>
    <p>
      <b
        >Deleting this custom field will delete all associated data from ALL INITIATIVES that may be
        using this currently.</b
      >
    </p>
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'
import service from '@/service'
import urlManager from '@/urlManager'
import showAPIError from '@/utils/showAPIError'
import showToast from '@/utils/showToast'

/**
 * This is the confirmation dialog that is shown when user tries to delete a custom field.
 */
export default {
  name: 'DeleteCfConfirmDialog',
  props: ['customField', 'orgId'],
  components: {
    ConfirmDialog
  },
  data() {
    return {}
  },
  computed: {
    deleteConfirmationTitle() {
      return `Delete "${this.customField?.name}" Custom Field?`
    },
    isOrgLevelCF() {
      return !this.customField?.projectId
    }
  },
  methods: {
    async deleteCustomField() {
      try {
        await service.client.delete(
          urlManager.CFDefinitionsDetail({
            orgId: this.orgId,
            customFieldId: this.customField.id
          })
        )
        this.$store.dispatch('getOrgCustomFields', { orgId: this.orgId })
        this.$emit('deleted', this.customField)
        showToast('Custom field has been deleted successfully')
      } catch (e) {
        showAPIError(e)
      }
    },
    show() {
      this.$refs.confirmModal.show()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
